module.exports = __webpack_public_path__ + "static/img/api.be2b9f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/api.png
// module id = Zj9+
// module chunks = 0